import localforage from 'localforage';

export const useAsyncCacheData = () => {
  const getStorageUnitlPromise = async <T>(options: { key: string; getData: () => Promise<T>; setData: (data: T) => void }) => {
    const dataFromStorage = await localforage.getItem<string>(options.key);

    if (dataFromStorage) {
      const dataFromStorageParsed = JSON.parse(dataFromStorage);
      options.setData(dataFromStorageParsed);
      loadData();
    } else {
      const data = await loadData();
      localforage.setItem(options.key, JSON.stringify(data));
    }

    async function loadData() {
      const data = await options.getData();
      if (data) {
        options.setData(data);
        localforage.setItem(options.key, JSON.stringify(data));
      }
    }
  };

  return { getStorageUnitlPromise };
};
